const React = require('react');
const noop = require('mn-utils/noop');
const SettingsBackupRestoreIcon
  = require('@material-ui/icons/SettingsBackupRestore').default;
const {
  paramStore,
} = require('../../../stores');
const {
  apiTestingWalletQr,
} = require('../../../api/testing/walletQr');
const withState = require('../../../utils/withState');
const LayoutA = require('../../dumb/Layout/A');
const HeaderA = require('../../dumb/Header/A');
const CaptionA = require('../../dumb/Caption/A');
const WrapperWithLoading = require('../../dumb/WrapperWithLoading');
const QRCode = require('../../dumb/QRCode');
const TextField = require('../../dumb/TextField/G');
const ButtonF = require('../../dumb/Button/F');


const wallet$ = paramStore('wallet', '');
const amount$ = paramStore('amount', '');
const asset$ = paramStore('asset', '');
const network$ = paramStore('network', '');


module.exports = withState((setState, self, onMount) => {
  let _cancel = noop;
  function update() {
    const {
      state,
    } = self;
    setState({
      loading: true,
    });
    _cancel = apiTestingWalletQr({
      wallet: state.wallet,
      asset: `${state.network}_${state.asset}`,
      amount: state.amount,
    }).finally((error, response) => {
      const next = {
        loading: false,
      };
      error || (next.invoice = next.invoiceOrigin = response.invoice);
      setState(next);
    }).cancel;
  }

  onMount(() => {
    update();
    return () => {
      _cancel();
    };
  });
  return (state, props) => {
    const invoiceOrigin = state.invoiceOrigin || '';
    const invoice = state.invoice || '';
    const wallet = state.wallet || '';
    const amount = state.amount || '';
    const asset = state.asset || '';
    const network = state.network || '';
    const {
      loading,
    } = state;

    return (
      <LayoutA>
        <HeaderA>
          <CaptionA>Wallet QR testing</CaptionA>
        </HeaderA>
        <WrapperWithLoading
          className="w400 mt20 stroke0>circle"
          loading={loading}
        >
          <div className="layoutRow fhaS fvaC w">
            <TextField
              className="fx1"
              label="Invoice code"
              value={invoice}
              onChange={(e) => {
                setState({
                  invoice: e.target.value,
                });
              }}
            />
            <ButtonF
              disabled={invoiceOrigin === invoice}
              className="ml15"
              onClick={() => {
                setState({
                  invoice: invoiceOrigin,
                });
              }}
            >
              <SettingsBackupRestoreIcon/>
            </ButtonF>
          </div>
          <div className="layoutRow fhaC fvaC w mt30">
            <div className="layoutRow fhaC fvaC sq200 bgF">
              <QRCode
                className="sq160 mhA"
                text={invoice}
                options={{
                  colorDark: '#000000',
                  colorLight: '#ffffff',
                  margin: 0,
                  errorCorrectionLevel: 'L',
                  width: 160,
                  height: 160,
                }}
              />
            </div>
          </div>
          <div className="mt30">
            <TextField
              className="w"
              label="Wallet ID"
              value={wallet}
              onChange={(e) => {
                wallet$.emit(e.target.value);
              }}
            />
            <div className="layoutRow fhaS fvaC mt15">
              <TextField
                className="w170"
                label="Amount"
                value={amount}
                onChange={(e) => {
                  amount$.emit(e.target.value);
                }}
              />
              <TextField
                className="ml15 w100"
                label="Network"
                value={network}
                onChange={(e) => {
                  network$.emit(e.target.value);
                }}
              />
              <TextField
                className="ml15 w100"
                label="Asset"
                value={asset}
                onChange={(e) => {
                  asset$.emit(e.target.value);
                }}
              />
            </div>
            <ButtonF
              className="mt30"
              onClick={update}
            >Update</ButtonF>
          </div>
        </WrapperWithLoading>
      </LayoutA>
    );
  };
}, {
  wallet: wallet$,
  amount: amount$,
  asset: asset$,
  network: network$,
});
